<script>
import moment from 'moment-timezone'

export default {
  name: 'DateSelector',
  props: {
    modelValue: {
      type: Date,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  emits: [
    'update:modelValue',
  ],
  data () {
    return {
      datePicker: false,
      date: null,
    }
  },
  computed: {
    dateText () {
      if (this.modelValue) {
        const date = moment(this.modelValue).format('DD/MM/YYYY')
        return date
      }
      return ''
    },
  },
  methods: {
    onClickNewDate (newValue) {
      this.datePicker = false
      this.$emit('update:modelValue', newValue)
    },
  },
}
</script>
<template>
  <v-dialog
    v-model="datePicker"
    width="290px"
  >
    <template v-slot:activator="{ props }">
      <v-text-field
        :model-value="dateText"
        :label="label"
        readonly
        v-bind="props"
      />
    </template>
    <v-date-picker
      v-model="date"
      @update:model-value="onClickNewDate"
    />
  </v-dialog>
</template>
